import * as SelectData from '../constants/CustomSelectData'
import * as Consts from '../constants/Consts';
import { TaskType, TaskStatus } from '../constants/Consts';
import * as WFSteps from '../constants/WorkflowSteps';
import * as Security from '../../utils/auth/Security';
import {EntityType} from '../constants/Consts';


export const getRoleDescription = (roleId) => {

    var role = SelectData.roleSystem.find( value => value.id === roleId );
    if(!role) {
        role = SelectData.roleClient.find( value => value.id === roleId );
    }
    if(!role) {
        role = SelectData.roleSubcontractor.find( value => value.id === roleId );
    }

    return role?.name;
}

export const getClientTypeName = (selectedClientType) => {
    const clientType = SelectData.clientTypeOptions.find(clientType => clientType.id === selectedClientType)
    return clientType ? clientType.name : '';
}

export const getClientServiceTypeName = (selectedClientServType) => {
    const clientServType = SelectData.clientServiceTypeOptions.find(clientServType => clientServType.id === selectedClientServType)
    return clientServType ? clientServType.name : '';
}


export const getClientSelectData = (clients) => {
    const clientSelectData = clients.map( (client) => ({ id: client.id, name: client.generalSection.clientName }));

    return clientSelectData;
}

export const getEmployerSelectData = (employers) => {
    return employers.map( (employer) => ({ id: employer.id, name: employer.generalSection.employerName }));
}

export const getSelectItemDescription = (itemId, selectData) => {
    const item = selectData.find( value => value.id === itemId);
    return item ? item.name : '';
}


export const getWorksiteSelectData = (selectedEmployerId, worksites, allWS) => {
    const worksiteList = worksites
                        .filter((worksite) => worksite.generalSection.employerId === selectedEmployerId)
                        .map( (worksite) => ({id: worksite.id, name: worksite.generalSection.name + ', ' + worksite.generalSection.localitate}) );

    if(allWS)
        return [{ id: -1, name: 'Toate...'}].concat(worksiteList);
    else
        return worksiteList;
}


export const getAuthzIscirName = (authIscirId) => {
    const authzNameArray  = SelectData.angajatAutorizatIscir.filter( (aa) => aa.id===authIscirId ).map( (aa) => aa.name );
    return authzNameArray.length > 0 ? authzNameArray[0] :  '';
}

export const getAuthzsIscirStatusName = (authIscirStatus) => {
    const authzStatusArray = SelectData.authorizationStatusOptions.filter( (as) => as.id===authIscirStatus ).map( (as) => as.name );
    return authzStatusArray.length > 0 ? authzStatusArray[0] : '';
}

export const getAuthzInternalName = (authzInternalId) => {
    const authz  = SelectData.angajatAutorizatIntern.find( (aa) => aa.id===authzInternalId );
    return authz ? authz.name :  '';
}

export const getCimStatusName = (cimId) => {
    const cimArray = SelectData.employeeContractStatus.filter( (as) => as.id===cimId ).map( (as) => as.name );
    return cimArray.length > 0 ? cimArray[0] : '';
}

export const getAuthzTypeName = (authzType) => {
    var typeName = '';

    switch(authzType) {
        case EntityType.AuthzIscir:
            typeName = "ISCIR";
            break;
        case EntityType.AuthzIntern:
            typeName = "Intern";
            break;
        default:
            typeName = 'NA'
    }

    return typeName;
}

export const getReminderName = (reminderType) => {
    var reminderName = "";

    switch(reminderType) {
        case Consts.REMINDER_RENEW_COUPON_STAMP:
            reminderName = "Reinnoire Viza Talon";
            break;
        case Consts.REMINDER_RENEW_COUPON:
            reminderName = "Reinnoire Talon";
            break;
        case Consts.REMINDER_RENEW_AUTHORIZATION:
            reminderName = "Reinnoire Autorizatie";
            break;
        case Consts.REMINDER_RENEW_CERTIFICATE:
            reminderName = "Reinnoire Adeverinta";
            break;
        default:
            reminderName = 'NA';
    }

    return reminderName;
}

export const getDeserventiTaskName = (taskType) => {
    var taskName = '';

    switch(taskType) {
        case TaskType.CouponStampRenewal:
            taskName = 'Reinnoire viza talon';
            break;
        case TaskType.CertificateRenewal:
            taskName = 'Reinoire certificat';
            break;
        default:
            taskName = 'NA';
        }

    return taskName;
}

export const getDeserventiTaskStepName = (stepNo) => {
    if(stepNo === WFSteps.couponStampRenealSteps.length){
        return (stepNo + 1) + ' - Summary';
    } 
    else{
        return (stepNo + 1) + ' - ' + WFSteps.couponStampRenealSteps[stepNo];
    }
}

export const getDeserventiTaskStatus = (taskStatus) => {
    var taskStatusDesc = '';

    switch(taskStatus) {
        case TaskStatus.InProgress:
            taskStatusDesc = 'In lucru';
            break;
        case TaskStatus.Completed:
            taskStatusDesc = 'Finalizat';
            break;
        case TaskStatus.Cancelled:
            taskStatusDesc = 'Anulat';
            break;
        default:
            taskStatusDesc = 'NA';
        }

        return taskStatusDesc;
}



export const getRsvtiOperatorSelectData = (operators) => {
    // return operators.map( (operator) => ({ id: operator.id, name: operator.generalSection.lastName + ' ' + operator.generalSection.firstName}));
    return operators.map( (operator) => ({ id: operator.generalSection.username, name: operator.generalSection.lastName + ' ' + operator.generalSection.firstName}));
}
